import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { POST_DOCUMENT } from "./apiRoutes";

interface UseGetPostedDocListProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPostedDocumentList = async (data: any) =>
  await axiosAuth.post(`${POST_DOCUMENT}/grid`, data);

const useGetPostedDocumentList = ({
  data,
  queryParams,
}: UseGetPostedDocListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["posted-documents"],
    queryFn: () => getPostedDocumentList(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPostedDocumentList;
